import { render } from "./salarySlipReport.vue?vue&type=template&id=5394c336&scoped=true"
import script from "./salarySlipReport.vue?vue&type=script&lang=js"
export * from "./salarySlipReport.vue?vue&type=script&lang=js"

import "./salarySlipReport.vue?vue&type=style&index=0&id=5394c336&scoped=true&lang=css"
import "./salarySlipReport.vue?vue&type=style&index=1&id=5394c336&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5394c336"]])

export default __exports__